import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  FormControlLabel,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SendIcon from "@material-ui/icons/Send";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import Videocam from "@material-ui/icons/Videocam";
import Audiotrack from "@material-ui/icons/Audiotrack";
import InsertDriveFile from "@material-ui/icons/InsertDriveFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

/** Resolve variáveis Mustache para exibição no preview (valores de exemplo). */
function resolveMustachePreview(text) {
  if (!text || typeof text !== "string") return text;
  const now = new Date();
  const hh = now.getHours();
  let ms = "Bom dia";
  if (hh > 11) ms = "Boa tarde";
  if (hh > 17) ms = "Boa noite";
  if (hh > 23 || hh < 6) ms = "Boa madrugada";
  const dd = ("0" + now.getDate()).slice(-2);
  const mm = ("0" + (now.getMonth() + 1)).slice(-2);
  const yy = now.getFullYear();
  const date = `${dd}-${mm}-${yy}`;
  const hour = `${now.getHours()}:${("0" + now.getMinutes()).slice(-2)}:${("0" + now.getSeconds()).slice(-2)}`;
  const data_hora = `${date} às ${hour}`;
  const view = {
    ms,
    date,
    hour,
    data_hora,
    name: "João Silva",
    firstName: "João",
    number: "",
    var1: "",
    var2: "",
    var3: "",
    var4: "",
    var5: "",
    var6: "",
    ticket_id: "",
    userName: "",
    queue: "",
    connection: "",
    protocol: "",
    name_company: "",
  };
  return text.replace(/\{\{(\w+)\}\}/g, (_, key) => (view[key] !== undefined ? view[key] : `{{${key}}}`));
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(3),
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  formColumn: {
    flex: "1 1 400px",
    minWidth: 320,
    maxWidth: 600,
  },
  previewColumn: {
    flex: "0 0 320px",
    position: "sticky",
    top: theme.spacing(2),
  },
  backButton: { marginRight: theme.spacing(1) },
  field: { marginBottom: theme.spacing(2) },
  submit: { marginTop: theme.spacing(2) },
  results: {
    marginTop: theme.spacing(2),
    maxHeight: 300,
    overflowY: "auto",
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
  },
  resultItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 1),
    borderRadius: 8,
    marginBottom: theme.spacing(0.5),
    "&:last-child": { marginBottom: 0 },
  },
  resultSuccess: {
    backgroundColor: "rgba(76, 175, 80, 0.08)",
  },
  resultError: {
    backgroundColor: "rgba(244, 67, 54, 0.08)",
  },
  resultSummary: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  resultSummaryItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    fontWeight: 600,
    fontSize: "0.85rem",
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '""',
      width: 4,
      height: 20,
      backgroundColor: theme.palette.primary.main,
      marginRight: theme.spacing(1),
      borderRadius: 2,
    },
  },
  mediaButtons: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  mediaButton: {
    flex: "1 1 100px",
    minWidth: 90,
    padding: theme.spacing(2),
    border: `2px dashed ${theme.palette.grey[400] || "#bdbdbd"}`,
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: theme.palette.grey[50] || "#fafafa",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main + "08",
    },
  },
  mediaButtonActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main + "14",
    borderStyle: "solid",
    "& svg": { color: theme.palette.primary.main },
  },
  mediaRow: { display: "flex", alignItems: "center", gap: theme.spacing(1), marginBottom: theme.spacing(2) },
  mediaLabel: { flex: 1 },
  inputFile: { display: "none" },
  previewTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: "0.75rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  phoneFrame: {
    width: 280,
    minHeight: 420,
    backgroundColor: "#1a1a1a",
    borderRadius: 28,
    padding: 10,
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
  },
  phoneNotch: {
    height: 24,
    borderRadius: 12,
    backgroundColor: "#1a1a1a",
    margin: "0 auto 8px",
    width: 80,
  },
  phoneScreen: {
    backgroundColor: "#0b141a",
    borderRadius: 20,
    overflow: "hidden",
    minHeight: 380,
    display: "flex",
    flexDirection: "column",
  },
  phoneHeader: {
    backgroundColor: "#1f2c34",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  phoneAvatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#00a884",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
  },
  phoneHeaderName: { color: "#e9edef", fontSize: 14, fontWeight: 500 },
  phoneHeaderStatus: { color: "#8696a0", fontSize: 12 },
  phoneChat: {
    flex: 1,
    padding: 16,
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23182229' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    backgroundColor: "#0b141a",
  },
  messageBubble: {
    backgroundColor: "#005c4b",
    borderRadius: "8px 8px 0 8px",
    padding: "8px 12px",
    maxWidth: "85%",
    marginLeft: "auto",
    marginBottom: 8,
  },
  messageText: { color: "#e9edef", fontSize: 13, lineHeight: 1.4, whiteSpace: "pre-wrap", wordBreak: "break-word" },
  messageTime: { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4, marginTop: 4 },
  messageTimeText: { color: "#8696a0", fontSize: 11 },
  emptyPreview: { color: "#8696a0", fontSize: 13, textAlign: "center", padding: 24 },
  previewMedia: { borderRadius: 8, marginBottom: 4, overflow: "hidden", maxWidth: "100%" },
  previewMediaImg: { maxWidth: "100%", maxHeight: 200, display: "block" },
  previewMediaPlaceholder: {
    padding: 16,
    backgroundColor: "#1f2c34",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
}));

const Broadcast = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const connectionId = params.get("connectionId");
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const audioInputRef = useRef(null);
  const docInputRef = useRef(null);

  const [groups, setGroups] = useState([]);
  const [groupSearch, setGroupSearch] = useState("");
  const [selected, setSelected] = useState({});
  const [message, setMessage] = useState("");
  const [mediaFile, setMediaFile] = useState(null);
  const [mediaType, setMediaType] = useState(null); // "image" | "video" | "audio" | "document"
  const [mediaPreviewUrl, setMediaPreviewUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!mediaFile) {
      setMediaPreviewUrl("");
      return;
    }
    const url = URL.createObjectURL(mediaFile);
    setMediaPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [mediaFile]);

  useEffect(() => {
    if (!connectionId) {
      history.replace("/group-management");
      return;
    }
    const fetchGroups = async () => {
      try {
        const { data } = await api.get(`/group-management/connections/${connectionId}/groups`);
        setGroups(Array.isArray(data) ? data : []);
        setSelected({});
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, [connectionId, history]);

  const searchLower = (groupSearch || "").trim().toLowerCase();
  const filteredGroups = searchLower
    ? groups.filter((g) => (g.subject || g.id || "").toLowerCase().includes(searchLower))
    : groups;

  const toggle = (id) => {
    setSelected((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const selectAll = (checked) => {
    const next = { ...selected };
    filteredGroups.forEach((g) => (next[g.id] = checked));
    setSelected(next);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selectedList = groups.filter((g) => selected[g.id]);
    const groupJids = selectedList.map((g) => g.id);
    const groupsPayload = selectedList.map((g) => ({ id: g.id, subject: g.subject || g.id }));
    const hasText = message.trim().length > 0;
    const hasMedia = !!mediaFile;
    if (!groupJids.length) {
      toastError(new Error(i18n.t("groupManagement.selectGroupsAndMessage")));
      return;
    }
    if (!hasText && !hasMedia) {
      toastError(new Error(i18n.t("groupManagement.selectGroupsAndMessage")));
      return;
    }
    setSending(true);
    setResults(null);
    try {
      let data;
      if (hasMedia) {
        const formData = new FormData();
        formData.append("connectionId", String(connectionId));
        formData.append("groupJids", JSON.stringify(groupJids));
        formData.append("groups", JSON.stringify(groupsPayload));
        formData.append("message", message.trim());
        formData.append("media", mediaFile);
        const res = await api.post("/group-management/broadcast", formData);
        data = res.data;
      } else {
        const res = await api.post("/group-management/broadcast", {
          connectionId: Number(connectionId),
          groupJids,
          groups: groupsPayload,
          message: message.trim(),
        });
        data = res.data;
      }
      setResults(data.results || []);
      const ok = (data.results || []).filter((r) => r.success).length;
      toast.success(i18n.t("groupManagement.broadcastSent", { count: ok, total: groupJids.length }));
    } catch (err) {
      toastError(err);
    } finally {
      setSending(false);
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files?.[0];
    setMediaFile(file || null);
    setMediaType(file ? type : null);
    [imageInputRef, videoInputRef, audioInputRef, docInputRef].forEach((ref) => {
      if (ref.current) ref.current.value = "";
    });
  };
  const clearMedia = () => {
    setMediaFile(null);
    setMediaType(null);
    [imageInputRef, videoInputRef, audioInputRef, docInputRef].forEach((ref) => {
      if (ref.current) ref.current.value = "";
    });
  };

  if (!connectionId) return null;

  const hasContent = Boolean(message.trim()) || Boolean(mediaFile);

  return (
    <MainContainer>
      <MainHeader>
        <Button className={classes.backButton} onClick={() => history.push("/group-management")} startIcon={<ArrowBackIcon />}>
          {i18n.t("groupManagement.back")}
        </Button>
        <Title>{i18n.t("groupManagement.broadcast")}</Title>
      </MainHeader>

      <Box className={classes.root}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
          <Paper className={classes.formColumn} style={{ padding: 24 }}>
            <form onSubmit={handleSubmit}>
              <Typography variant="subtitle2" gutterBottom>
                {i18n.t("groupManagement.selectGroupsToSend")}
              </Typography>
              <Box display="flex" flexWrap="wrap" alignItems="center" gap={2} marginBottom={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      indeterminate={filteredGroups.length > 0 && filteredGroups.some((g) => selected[g.id]) && !filteredGroups.every((g) => selected[g.id])}
                      checked={filteredGroups.length > 0 && filteredGroups.every((g) => selected[g.id])}
                      onChange={(e) => selectAll(e.target.checked)}
                    />
                  }
                  label={i18n.t("groupManagement.selectAll")}
                />
                <TextField
                  size="small"
                  placeholder={i18n.t("groupManagement.searchGroups")}
                  value={groupSearch}
                  onChange={(e) => setGroupSearch(e.target.value)}
                  variant="outlined"
                  style={{ minWidth: 180 }}
                  inputProps={{ "aria-label": i18n.t("groupManagement.searchGroups") }}
                />
              </Box>
              <List dense style={{ maxHeight: 200, overflow: "auto" }}>
                {filteredGroups.map((g) => (
                  <ListItem key={g.id} button onClick={() => toggle(g.id)}>
                    <Checkbox checked={!!selected[g.id]} />
                    <ListItemText primary={g.subject || g.id} />
                  </ListItem>
                ))}
              </List>

              <Typography className={classes.sectionTitle}>
                {i18n.t("groupManagement.sendMedia")}
              </Typography>
              <Box className={classes.mediaButtons}>
                <input ref={imageInputRef} type="file" className={classes.inputFile} accept="image/*" onChange={(e) => handleFileChange(e, "image")} id="broadcast-image" />
                <label htmlFor="broadcast-image" style={{ flex: "1 1 100px", minWidth: 90 }}>
                  <Box className={`${classes.mediaButton} ${mediaType === "image" ? classes.mediaButtonActive : ""}`} component="span">
                    <PhotoCamera style={{ fontSize: 28 }} />
                    <Typography variant="caption" style={{ marginTop: 4 }}>{i18n.t("groupManagement.mediaImage")}</Typography>
                  </Box>
                </label>
                <input ref={videoInputRef} type="file" className={classes.inputFile} accept="video/*" onChange={(e) => handleFileChange(e, "video")} id="broadcast-video" />
                <label htmlFor="broadcast-video" style={{ flex: "1 1 100px", minWidth: 90 }}>
                  <Box className={`${classes.mediaButton} ${mediaType === "video" ? classes.mediaButtonActive : ""}`} component="span">
                    <Videocam style={{ fontSize: 28 }} />
                    <Typography variant="caption" style={{ marginTop: 4 }}>{i18n.t("groupManagement.mediaVideo")}</Typography>
                  </Box>
                </label>
                <input ref={audioInputRef} type="file" className={classes.inputFile} accept="audio/*" onChange={(e) => handleFileChange(e, "audio")} id="broadcast-audio" />
                <label htmlFor="broadcast-audio" style={{ flex: "1 1 100px", minWidth: 90 }}>
                  <Box className={`${classes.mediaButton} ${mediaType === "audio" ? classes.mediaButtonActive : ""}`} component="span">
                    <Audiotrack style={{ fontSize: 28 }} />
                    <Typography variant="caption" style={{ marginTop: 4 }}>{i18n.t("groupManagement.mediaAudio")}</Typography>
                  </Box>
                </label>
                <input ref={docInputRef} type="file" className={classes.inputFile} accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={(e) => handleFileChange(e, "document")} id="broadcast-doc" />
                <label htmlFor="broadcast-doc" style={{ flex: "1 1 100px", minWidth: 90 }}>
                  <Box className={`${classes.mediaButton} ${mediaType === "document" ? classes.mediaButtonActive : ""}`} component="span">
                    <InsertDriveFile style={{ fontSize: 28 }} />
                    <Typography variant="caption" style={{ marginTop: 4 }}>{i18n.t("groupManagement.mediaDocument")}</Typography>
                  </Box>
                </label>
              </Box>
              {mediaFile && (
                <Box className={classes.mediaRow}>
                  <Typography className={classes.mediaLabel} variant="body2" color="textSecondary" noWrap>
                    {mediaFile.name}
                  </Typography>
                  <IconButton size="small" onClick={clearMedia} title={i18n.t("groupManagement.removeMedia")}>
                    <DeleteOutlineIcon />
                  </IconButton>
                </Box>
              )}
              <TextField
                className={classes.field}
                fullWidth
                multiline
                rows={4}
                label={i18n.t("groupManagement.message")}
                placeholder={mediaFile ? i18n.t("groupManagement.messageCaptionHint") : undefined}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                variant="outlined"
                spellCheck={false}
                helperText={!message.trim() && !mediaFile ? i18n.t("groupManagement.messageOrMediaRequired") : null}
              />
              <Button className={classes.submit} type="submit" variant="contained" color="primary" disabled={sending} startIcon={sending ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}>
                {sending ? i18n.t("groupManagement.sendBroadcast") + "..." : i18n.t("groupManagement.sendBroadcast")}
              </Button>
            </form>
            {results && results.length > 0 && (() => {
              const okCount = results.filter((r) => r.success).length;
              const failCount = results.length - okCount;
              return (
                <Box className={classes.results}>
                  <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 700 }}>
                    {i18n.t("groupManagement.results")}
                  </Typography>
                  <Box className={classes.resultSummary}>
                    <Box className={classes.resultSummaryItem} style={{ color: "#4CAF50" }}>
                      <CheckCircleOutlineIcon style={{ fontSize: 18 }} />
                      {okCount} OK
                    </Box>
                    {failCount > 0 && (
                      <Box className={classes.resultSummaryItem} style={{ color: "#F44336" }}>
                        <ErrorOutlineIcon style={{ fontSize: 18 }} />
                        {failCount} {failCount === 1 ? "erro" : "erros"}
                      </Box>
                    )}
                  </Box>
                  {results.map((r, i) => {
                    const groupName = groups.find((g) => g.id === r.groupJid)?.subject || r.groupJid;
                    return (
                      <Box
                        key={i}
                        className={`${classes.resultItem} ${r.success ? classes.resultSuccess : classes.resultError}`}
                      >
                        {r.success ? (
                          <CheckCircleOutlineIcon style={{ fontSize: 18, color: "#4CAF50" }} />
                        ) : (
                          <ErrorOutlineIcon style={{ fontSize: 18, color: "#F44336" }} />
                        )}
                        <Typography variant="body2" style={{ flex: 1, fontWeight: 500 }} noWrap>
                          {groupName}
                        </Typography>
                        {!r.success && (
                          <Typography variant="caption" color="error" style={{ maxWidth: 180 }} noWrap>
                            {r.error}
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              );
            })()}
          </Paper>

          <Box className={classes.previewColumn}>
            <Typography className={classes.previewTitle} component="div">
              <ListAltIcon fontSize="small" />
              {i18n.t("groupManagement.previewTitle")}
            </Typography>
            <Box className={classes.phoneFrame}>
              <Box className={classes.phoneNotch} />
              <Box className={classes.phoneScreen}>
                <Box className={classes.phoneHeader}>
                  <Box className={classes.phoneAvatar}>J</Box>
                  <Box>
                    <Typography className={classes.phoneHeaderName}>João Silva</Typography>
                    <Typography className={classes.phoneHeaderStatus}>online</Typography>
                  </Box>
                </Box>
                <Box className={classes.phoneChat}>
                  {hasContent ? (
                    <Box className={classes.messageBubble}>
                      {mediaFile && (
                        <Box className={classes.previewMedia}>
                          {mediaType === "image" && mediaPreviewUrl ? (
                            <img src={mediaPreviewUrl} alt="" className={classes.previewMediaImg} />
                          ) : mediaType === "video" && mediaPreviewUrl ? (
                            <video src={mediaPreviewUrl} controls className={classes.previewMediaImg} />
                          ) : (
                            <Box className={classes.previewMediaPlaceholder}>
                              {mediaType === "audio" && <Audiotrack style={{ color: "#e9edef" }} />}
                              {mediaType === "document" && <InsertDriveFile style={{ color: "#e9edef" }} />}
                              <Typography variant="caption" style={{ color: "#e9edef" }}>
                                {mediaFile?.name || (mediaType === "audio" ? i18n.t("groupManagement.mediaAudio") : i18n.t("groupManagement.mediaDocument"))}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )}
                      {message.trim() && (
                        <Typography className={classes.messageText}>{resolveMustachePreview(message)}</Typography>
                      )}
                      <Box className={classes.messageTime}>
                        <DoneAllIcon style={{ fontSize: 14, color: "#53bdeb" }} />
                        <span className={classes.messageTimeText}>Agora</span>
                      </Box>
                    </Box>
                  ) : (
                    <Typography className={classes.emptyPreview}>
                      {i18n.t("groupManagement.previewEmpty")}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          </>
        )}
      </Box>
    </MainContainer>
  );
};

export default Broadcast;
